<div class="theming-crud mm-page">
  <header class="qa-theming-header">
    <div class="qa-theming-title">
      <h2>{{_(KEYS.THEMING.THEMING)}}</h2>
      <p>{{_("Farben, Schrift und Logos für die Ausfüll-App, den PDF-Briefkopf und die Verwaltungsoberfläche.")}}</p>
    </div>
  </header>

  <ul ngbNav #themingTabs="ngbNav" [(activeId)]="activeTab" class="nav-tabs qa-theming-tabs">
    <li [ngbNavItem]="'app'">
      <a ngbNavLink><i class="fa fa-mobile" aria-hidden="true"></i> {{_(KEYS.THEMING.APP)}}</a>
      <ng-template ngbNavContent>
        <div class="qa-theming-tabbar">
          <p>{{_("Farben, Schrift und Logos für die Ausfüll-App und den PDF-Briefkopf.")}}</p>
          <div class="qa-theming-actions">
            <button type="button" class="qa-theming-switch" role="switch" [attr.aria-checked]="!!theming.active" (click)="onToggle()">
              <span class="qa-switch-track" aria-hidden="true"><span class="qa-switch-thumb"></span></span>
              {{theming.active ? _("Theming aktiv") : _("Theming deaktiviert")}}
            </button>
            <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!canSave()">
              <i class="fa fa-save" aria-hidden="true"></i> {{_("Speichern")}}
            </button>
          </div>
        </div>

        <div *ngIf="!canSave()" class="qa-theming-hint" role="note">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          {{_("Für Speichern und Vorschau werden Hauptfarbe und App-Logo benötigt.")}}
        </div>

        <div class="qa-theming-layout">
          <div class="qa-theming-sections">

            <section class="qa-theming-card">
              <h3><i class="fa fa-mobile" aria-hidden="true"></i> {{_("Ausfüll-Oberfläche")}}</h3>

              <div class="qa-theming-fields">
                <div class="qa-theming-field">
                  <label for="bgcolor">{{_("Hauptfarbe")}}</label>
                  <div class="qa-color-input">
                    <span class="qa-color-swatch" [style.background]="theming.mainColor || 'transparent'" aria-hidden="true"></span>
                    <input
                      class="form-control" id="bgcolor" spellcheck="false" autocomplete="off"
                      [colorPicker]="theming.mainColor"
                      (colorPickerChange)="onMainColorChange($event)"
                      [value]="theming.mainColor || ''"
                      [cpPosition]="'bottom'"
                      [cpOKButtonClass]="'btn btn-primary'"
                      [cpSaveClickOutside]="true"
                      [cpOKButton]="true"
                    />
                  </div>
                </div>

                <div class="qa-theming-field">
                  <label for="font">{{_("Schriftart")}}</label>
                  <select id="font" class="form-control" [(ngModel)]="theming.font" (change)="onFontChange()">
                    <option value="Asap">Asap</option>
                    <option value="Open Sans">Open Sans</option>
                    <option value="Caveat">Caveat</option>
                    <option value="Exo">Exo</option>
                    <option value="Roboto Condensed">Roboto Condensed</option>
                  </select>
                </div>
              </div>

              <div class="qa-theming-field">
                <label>{{_("Oberfläche Logo")}}</label>
                <div class="qa-logo-tile">
                  <button type="button" class="qa-logo-stage" [class.qa-logo-empty]="!theming.logo" (click)="onOpenMediaCenterModalForLogo()"
                          [attr.aria-label]="theming.logo ? _('Logo ändern') : _('Logo wählen')">
                    <img *ngIf="theming.logo; else noLogo" [src]="theming.logo.dataUrl" alt="" />
                    <ng-template #noLogo><i class="fa fa-picture-o" aria-hidden="true"></i><span>{{_("Kein Logo")}}</span></ng-template>
                  </button>
                  <div class="qa-logo-actions">
                    <button type="button" class="btn btn-outline-secondary" (click)="onOpenMediaCenterModalForLogo()">
                      <i class="fa fa-folder-open-o" aria-hidden="true"></i> {{theming.logo ? _("Logo ändern") : _("Logo wählen")}}
                    </button>
                    <button type="button" class="qa-icon-action qa-icon-action-danger" (click)="onDeleteLogo()" [disabled]="!theming.logo"
                            [attr.aria-label]="_('Entfernen')" [attr.title]="_('Entfernen')">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section class="qa-theming-card">
              <h3><i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{_("PDF-Briefkopf")}}</h3>

              <div class="qa-theming-field">
                <label>{{_("Briefkopf Logo")}}</label>
                <div class="qa-logo-tile">
                  <button type="button" class="qa-logo-stage" [class.qa-logo-empty]="!theming.logoPdf" (click)="onOpenMediaCenterModalForLogoPdf()"
                          [attr.aria-label]="theming.logoPdf ? _('Logo ändern') : _('Logo wählen')">
                    <img *ngIf="theming.logoPdf; else noLogoPdf" [src]="theming.logoPdf.dataUrl" alt="" />
                    <ng-template #noLogoPdf><i class="fa fa-picture-o" aria-hidden="true"></i><span>{{_("Kein Logo")}}</span></ng-template>
                  </button>
                  <div class="qa-logo-actions">
                    <button type="button" class="btn btn-outline-secondary" (click)="onOpenMediaCenterModalForLogoPdf()">
                      <i class="fa fa-folder-open-o" aria-hidden="true"></i> {{theming.logoPdf ? _("Logo ändern") : _("Logo wählen")}}
                    </button>
                    <button type="button" class="qa-icon-action qa-icon-action-danger" (click)="onDeleteLogoPdf()" [disabled]="!theming.logoPdf"
                            [attr.aria-label]="_('Entfernen')" [attr.title]="_('Entfernen')">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="qa-theming-fields">
                <div class="qa-theming-field">
                  <label>{{_("Briefkopf Position")}}</label>
                  <div class="qa-segments" role="radiogroup" [attr.aria-label]="_('Briefkopf Position')">
                    <button type="button" role="radio" [attr.aria-checked]="theming.logoPdfPosition === 'left'"
                            [class.active]="theming.logoPdfPosition === 'left'" (click)="onLogoPdfPositionChange('left')">
                      <i class="fa fa-align-left" aria-hidden="true"></i> {{_("Links")}}
                    </button>
                    <button type="button" role="radio" [attr.aria-checked]="theming.logoPdfPosition === 'center'"
                            [class.active]="theming.logoPdfPosition === 'center'" (click)="onLogoPdfPositionChange('center')">
                      <i class="fa fa-align-center" aria-hidden="true"></i> {{_("Mittig")}}
                    </button>
                    <button type="button" role="radio" [attr.aria-checked]="theming.logoPdfPosition === 'right'"
                            [class.active]="theming.logoPdfPosition === 'right'" (click)="onLogoPdfPositionChange('right')">
                      <i class="fa fa-align-right" aria-hidden="true"></i> {{_("Rechts")}}
                    </button>
                  </div>
                </div>

                <div class="qa-theming-field">
                  <label for="logo-pdf-height">{{_("Briefkopf Höhe")}}</label>
                  <div class="input-group qa-height-input">
                    <input id="logo-pdf-height" class="form-control" type="number" min="1" [(ngModel)]="theming.logoPdfHeight" />
                    <div class="input-group-addon">px</div>
                  </div>
                </div>
              </div>
            </section>

            <section class="qa-theming-card">
              <h3><i class="fa fa-code" aria-hidden="true"></i> {{_("Eigenes CSS")}}</h3>
              <p class="qa-theming-text">{{_("Mit eigenen CSS-Regeln lässt sich die Ausfüll-App über diese Einstellungen hinaus anpassen.")}}</p>
              <div class="qa-css-row">
                <span class="qa-css-status" [class.qa-css-set]="customCssLines">
                  <i class="fa" [ngClass]="customCssLines ? 'fa-check-circle' : 'fa-circle-o'" aria-hidden="true"></i>
                  {{customCssLines ? customCssLines + ' ' + _("Zeilen eigenes CSS") : _("Keine eigenen Regeln hinterlegt")}}
                </span>
                <button type="button" class="btn btn-outline-secondary" (click)="onOpenCustomCssDialog()">
                  <i class="fa fa-pencil" aria-hidden="true"></i> {{_("CSS bearbeiten")}}
                </button>
              </div>
            </section>
          </div>

          <aside class="qa-theming-preview" [attr.aria-label]="_('Vorschau')">
            <div class="qa-theming-card">
              <h3><i class="fa fa-eye" aria-hidden="true"></i> {{_("Vorschau")}}</h3>

              <div class="qa-mock-app" [style.font-family]="theming.font + ', sans-serif'" [style.--qa-main]="theming.mainColor || '#3ba79a'" aria-hidden="true">
                <div class="qa-mock-bar">
                  <img *ngIf="theming.logo" [src]="theming.logo.dataUrl" alt="" />
                  <span class="qa-mock-progress"><span></span></span>
                </div>
                <div class="qa-mock-body">
                  <div class="qa-mock-question">{{_("Wie geht es Ihnen heute?")}}</div>
                  <div class="qa-mock-option qa-mock-option-selected"><span></span>{{_("Gut")}}</div>
                  <div class="qa-mock-option"><span></span>{{_("Nicht so gut")}}</div>
                  <div class="qa-mock-button">{{_("Weiter")}}</div>
                </div>
              </div>

              <div class="qa-mock-label">{{_("PDF-Briefkopf")}}</div>
              <div class="qa-mock-paper" aria-hidden="true">
                <div class="qa-mock-letterhead" [style.justify-content]="logoPdfJustify">
                  <img *ngIf="theming.logoPdf; else noPdfMock" [src]="theming.logoPdf.dataUrl" alt=""
                       [style.height.px]="previewLogoPdfHeight" />
                  <ng-template #noPdfMock><span class="qa-mock-placeholder" [style.height.px]="previewLogoPdfHeight"></span></ng-template>
                </div>
                <div class="qa-mock-lines"><span></span><span></span><span></span></div>
              </div>

              <button type="button" class="btn btn-outline-secondary qa-preview-open" (click)="onOpenPreview(content)" [disabled]="!canSave()">
                <i class="fa fa-external-link" aria-hidden="true"></i> {{_("Live-Vorschau öffnen")}}
              </button>
            </div>
          </aside>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="'admin'">
      <a ngbNavLink><i class="fa fa-desktop" aria-hidden="true"></i> {{_(KEYS.THEMING.ADMIN)}}</a>
      <ng-template ngbNavContent>
        <app-admin-theming></app-admin-theming>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="themingTabs"></div>
</div>

<ng-template #content let-c="close">
  <div class="modal-header">
    <h4 class="modal-title">{{_("Vorschau")}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="c('')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <iframe [src]="previewUrl" *ngIf="previewUrl"></iframe>
  </div>
</ng-template>
